import React from 'react';
import { Crown, Users, ClipboardList, GraduationCap, Settings } from 'lucide-react';

export const ForWhoSection = () => {
  const roles = [
    {
      icon: Crown,
      title: 'Pastores',
      description: 'Una visión general de la comunidad. Indicadores de asistencia, formación, finanzas y crecimiento en un solo panel.',
      color: 'from-indigo-500 to-indigo-700',
    },
    {
      icon: Users,
      title: 'Líderes',
      description: 'Seguimiento de grupos, equipos y personas. Control de asistencia y estado de cada miembro de tu red.',
      color: 'from-emerald-500 to-emerald-700',
    },
    {
      icon: ClipboardList,
      title: 'Secretarías',
      description: 'Información organizada y accesible. Directorio, fichas, documentos y gestión administrativa centralizada.',
      color: 'from-violet-500 to-violet-700',
    },
    {
      icon: GraduationCap,
      title: 'Maestros',
      description: 'Control de formación y estudiantes. Registro de avance, calificaciones, asistencia a lecciones y certificación.',
      color: 'from-amber-500 to-amber-700',
    },
    {
      icon: Settings,
      title: 'Administradores',
      description: 'Finanzas, indicadores y procesos. Reportes, verificación de movimientos, tickets y permisos por rol.',
      color: 'from-rose-500 to-rose-700',
    },
  ];

  return (
    <section className="py-20 bg-white dark:bg-slate-900 border-t border-slate-200/60 dark:border-slate-800/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <p className="text-xs font-black uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
            ¿Para quién es?
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 dark:text-white tracking-tight">
            PastoreApp se adapta a{' '}
            <span className="bg-gradient-to-r from-indigo-600 to-violet-600 dark:from-indigo-400 dark:to-violet-400 bg-clip-text text-transparent">
              diferentes equipos
            </span>{' '}
            de tu iglesia
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {roles.map((role, idx) => {
            const Icon = role.icon;
            return (
              <div
                key={idx}
                className="bg-slate-50 dark:bg-slate-950 p-6 rounded-[2rem] border border-slate-200/80 dark:border-slate-800/80 space-y-4 text-center hover:shadow-xl hover:-translate-y-1 transition-all group"
              >
                <div className={`w-14 h-14 mx-auto rounded-2xl bg-gradient-to-br ${role.color} text-white flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform`}>
                  <Icon size={28} />
                </div>
                <h3 className="text-lg font-black text-slate-900 dark:text-white tracking-tight">{role.title}</h3>
                <p className="text-xs font-medium text-slate-600 dark:text-slate-400 leading-relaxed">
                  {role.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
